// src/Admin/adminpanel.jsx - 3Workers9 Responsive Edition (Updated Theme)
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FaUsers, FaTrophy, FaTasks, FaWallet, FaCog, FaChartBar, FaSignOutAlt, FaBullhorn, FaShieldAlt, FaBars, FaTimes,FaChartLine,FaGift 
} from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import TasksManager from './TaskManage';
import Alert from '../components/Alert';
import { useAppContext } from '../context/AppContext';
import AdminUsers from './AdminUsersPage';
import Leaderboard from './leaderBoard';
import AdminWithdraws from './AdminWithdraws';
import { useAdmin } from '../context/AdminContext';
import AdminAnnouncements from './AdminAnnouncements';
import AdminManualPlanActivate from './AdminManualPlanActivate';
import ThreeWorkersLogo from '../components/logo';
import ReportsDashboard from './ReportDashboard';
import AdminChangeWallet from './AdminChangeWallet';
import AddBonus from './IncBonus';

const AdminLayout = () => {
  const location = useLocation();
  const { showAlert, alert } = useAppContext();
  const { logoutAdmin } = useAdmin();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const sidebarItems = [
    { id: 'dashboard', icon: FaChartBar, label: 'Control Center', path: '/3workers_admin_hun_yara/dashboard' },
    { id: 'users', icon: FaUsers, label: 'Users', path: '/3workers_admin_hun_yara/users' },
 { id: 'reports', icon: FaChartLine, label: 'Withdraw proccessed', path: '/3workers_admin_hun_yara/report-user' }, // ID chhota kiya
    { id: 'leaderboard', icon: FaTrophy, label: 'Leaderboard', path: '/3workers_admin_hun_yara/leaderboard' },
    // { id: 'tasks', icon: FaTasks, label: 'Mission Tasks', path: '/3workers_admin_hun_yara/tasksmanage' },
    { id: 'announcements', icon: FaBullhorn, label: 'Global Broadcast', path: '/3workers_admin_hun_yara/announcements' },
    { id: 'manualActivatePlan', icon: FaShieldAlt, label: 'Manual Plan Activate', path: '/3workers_admin_hun_yara/manual-activate-plan' },
    {id: "wallet-change",
  icon: FaWallet,
  label: "Wallet Manager",
  path: "/3workers_admin_hun_yara/change-wallet"
},
     {id: "increasing bonus",
  icon: FaGift ,
  label: "Bonus Manager",
  path: "/3workers_admin_hun_yara/increasing-bonus"
},
  ];

  const ZoltaLogo = () => (
    <div className="flex items-center gap-3">
      {/* Dark Blue background with Yellow border and text */}
      <div className="w-10 h-10 bg-slate-900 text-yellow-400 rounded-xl flex items-center justify-center shadow-lg border border-yellow-400">
        <span className="font-black text-xl italic">3W</span>
      </div>
      <div className="flex flex-col">
        {/* Responsive text switching perfectly between mobile (White) and desktop (Dark Blue) */}
        <span className="text-white lg:text-white font-black tracking-tighter text-2xl leading-none my-2">3Workers</span>
        <span className="text-[10px] font-bold text-yellow-400 lg:text-slate-500 uppercase tracking-[0.3em]">Command Center</span>
      </div>
    </div>
  );

  const SidebarContent = () => (
    /* Sidebar: Main Dark Blue combination on both mobile and desktop views */
    <div className="h-full flex flex-col bg-slate-900 border-r border-slate-800 shadow-2xl">
      <div className="p-8 border-b border-slate-800 flex justify-between items-center">
        <ZoltaLogo />
        <button className="lg:hidden text-white hover:text-yellow-400 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
          <FaTimes size={24} />
        </button>
      </div>

      <nav className="p-6 space-y-2 flex-grow overflow-y-auto">
        // SidebarContent ke andar ye loop update karein:
{sidebarItems.map((item) => {
  // Exact path match use karein
  const isActive = location.pathname === item.path; 
  return (
    <Link
      key={item.id}
      to={item.path}
      onClick={() => setIsMobileMenuOpen(false)}
      className={`group flex items-center gap-4 px-4 py-4 rounded-2xl transition-all duration-300 ${
        isActive 
        ? 'bg-yellow-400 text-slate-950 shadow-xl shadow-yellow-400/10 font-bold' 
        : 'text-slate-400 hover:bg-slate-800 hover:text-yellow-400'
      }`}
    >
      <item.icon size={20} className={isActive ? 'text-slate-950' : 'group-hover:text-yellow-400'} />
      <span className="text-[11px] font-black uppercase tracking-widest">{item.label}</span>
    </Link>
  );
})}
      </nav>

      <div className="p-6 border-t border-slate-800">
        <button 
          onClick={logoutAdmin}
          className="w-full py-4 bg-rose-500/10 text-rose-400 rounded-2xl font-black text-[11px] uppercase tracking-[0.2em] hover:bg-rose-600 hover:text-white transition-all flex items-center justify-center gap-3 border border-rose-500/20"
        >
          <FaSignOutAlt /> Terminate Session
        </button>
      </div>
    </div>
  );

  const DashboardContent = () => (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-7xl mx-auto pt-6 lg:pt-10">
      {/* Clean Premium White Card with Dark Blue content text */}
      <div className="relative overflow-hidden bg-white border border-slate-100 rounded-[2rem] lg:rounded-[3rem] p-6 lg:p-12 shadow-xl shadow-slate-200/50">
        <div className="relative z-10">
          <h1 className="text-4xl lg:text-6xl font-black text-slate-900 tracking-tighter mb-4 lg:mb-6 leading-tight">
            Welcome, <br className="lg:hidden" /><span className="text-slate-900 bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">Commander.</span>
          </h1>
          <p className="text-slate-500 text-lg lg:text-xl font-medium max-w-2xl leading-relaxed">
            The ecosystem is running at <span className="text-emerald-600 font-bold px-2 py-0.5 bg-emerald-50 rounded-md">Optimal Performance</span>.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 mt-8 lg:mt-12">
            {[
              { label: 'Network Uptime', val: '99.98%' },
              { label: 'Active Protocols', val: '24/7' },
              { label: 'Security Level', val: 'Military' }
            ].map((stat, i) => (
              /* Stat boxes styled in balanced White/Light Gray background with Dark text pointers */
              <div key={i} className="p-5 lg:p-6 bg-slate-50 rounded-2xl border border-slate-100 transition-all hover:border-yellow-400/50">
                <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">{stat.label}</p>
                <p className="text-xl lg:text-2xl font-black text-slate-900 mt-1">{stat.val}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );

  return (
    /* Global Selection set to Yellow highlight for complete aesthetics */
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-yellow-200 overflow-x-hidden">
      <Alert
        type={alert.type}
        message={alert.message}
        isOpen={alert.isOpen}
        onClose={() => showAlert({ isOpen: false, type: '', message: '' })}
      />

      {/* Mobile Top Header - White Background with Dark Blue Icons */}
      <header className="lg:hidden bg-white border-b border-slate-200 p-4 sticky top-0 z-40 flex justify-between items-center shadow-sm">
        <ThreeWorkersLogo />
        <button onClick={() => setIsMobileMenuOpen(true)} className="p-2 text-slate-900 hover:text-yellow-500 transition-colors">
          <FaBars size={24} />
        </button>
      </header>

      {/* Sidebar - Desktop */}
      <aside className="hidden lg:block fixed left-0 top-0 h-screen w-72 z-50">
        <SidebarContent />
      </aside>

      {/* Sidebar - Mobile Overlay */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <>
            <motion.div 
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
              onClick={() => setIsMobileMenuOpen(false)}
              className="fixed inset-0 bg-slate-950/60 backdrop-blur-sm z-[60] lg:hidden"
            />
            <motion.aside 
              initial={{ x: '-100%' }} animate={{ x: 0 }} exit={{ x: '-100%' }}
              transition={{ type: 'spring', damping: 25, stiffness: 200 }}
              className="fixed left-0 top-0 h-screen w-[280px] z-[70] lg:hidden"
            >
              <SidebarContent />
            </motion.aside>
          </>
        )}
      </AnimatePresence>

      {/* Main Content Area */}
      <main className="lg:ml-72 min-h-screen p-4 lg:p-10">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4 }}
        >
          {           location.pathname === "/3workers_admin_hun_yara/report-user" ? <ReportsDashboard /> :
           location.pathname === "/3workers_admin_hun_yara" || location.pathname === "/3workers_admin_hun_yara/dashboard" ? <DashboardContent /> :
           location.pathname === "/3workers_admin_hun_yara/users" ? <AdminUsers /> :
           location.pathname === "/3workers_admin_hun_yara/leaderboard" ? <Leaderboard /> :
           location.pathname === "/3workers_admin_hun_yara/withdraws" ? <AdminWithdraws /> :
           location.pathname === "/3workers_admin_hun_yara/announcements" ? <AdminAnnouncements /> :
           location.pathname === "/3workers_admin_hun_yara/manual-activate-plan" ? <AdminManualPlanActivate /> :
           location.pathname === "/3workers_admin_hun_yara/increasing-bonus" ? <AddBonus /> :
           location.pathname === "/3workers_admin_hun_yara/change-wallet"
  ? <AdminChangeWallet />:
           <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
             <FaCog size={60} className="text-slate-300 animate-spin-slow mb-6" />
             <h2 className="text-2xl lg:text-3xl font-black text-slate-400 uppercase tracking-tighter">Under Construction</h2>
           </div>}
        </motion.div>
      </main>
    </div>
  );
};

export default AdminLayout;

